/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import { Box } from '@mui/material';
import { useConfirm } from 'material-ui-confirm';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IS_SA } from '../../../../config/appConfig';
import { AppRoutes } from '../../../../constants/appRoutes';
import { BecomeProStatuses } from '../../../../constants/becomeProStatus';
import { BucketTypes } from '../../../../constants/bucketTypes';
import { OTPTypes } from '../../../../constants/otpTypes';
import { currencyFormatterHelper } from '../../../../helpers/currencyFormatterHelper';
import { DateHelper } from '../../../../helpers/dateHelper';
import { buildLocalizeRoute } from '../../../../helpers/languageHelper';
import { getUser } from '../../../../services/authService';
import { BecomeProService } from '../../../../services/becomeProService';
import { LanguageService } from '../../../../services/languageService';
import { SystemSettingsService } from '../../../../services/systemSettingsService';
import { Section } from '../../../../shared/components/common/section';
import { CustomTooltip } from '../../../../shared/components/common/tooltip';
import { ButtonWrapper } from '../../../../shared/components/formUtilities/useButton';
import { TextWrapper } from '../../../../shared/components/formUtilities/useTextWrapper';
import { AutoInvestLoader } from '../../../../shared/components/investors/loaders/autoInvestmentLoader';
import { OTPAuthenticationDialog } from '../../../../shared/components/otpAuthenticationDialog';
import { InvestorService } from '../../investorService';
import { ConfirmAutoInvestDialog } from './confirmAutoInvestDailog';

export const AutoInvesting = () => {
	const investorService = new InvestorService();
	const becomeProService = new BecomeProService();
	const systemSettingsService = new SystemSettingsService();
	const languageService = new LanguageService();

	const staticAI = [
		{
			id: BucketTypes.Balanced,
			title: languageService.isArabic() ? 'الاستثمار الآلي المتوازن' : 'Balanced Auto Investing',
			roiPercent: IS_SA ? "13" : '15'
		},
		{
			id: BucketTypes.Conservative,
			title: languageService.isArabic() ? 'الاستثمار الآلي المتحفظ' : 'Conservative Auto Investing',
			roiPercent: "13"
		}
	];

	const [proStatus, setProStatus] = useState(null);
	const [summary, setSummary] = useState(null);
	const [availableCash, setAvailableCash] = useState(0);
	// eslint-disable-next-line no-unused-vars
	const [buckets, setBuckets] = useState(staticAI);
	const [activatedBucket, setActivatedBucket] = useState({});
	const [selectedBucket, setSelectedBucket] = useState(null);
	const [showOTPDialog, setShowOTPDialog] = useState(false);
	const [isOpenBucketDialog, setIsOpenBucketDialog] = useState(false);
	const queryParams = new URLSearchParams(window.location.search);
	const activateInvest = queryParams.get('activateInvest');
	const confirm = useConfirm();

	const currentYear = new Date().getFullYear();

	const [loading, setLoading] = useState(true);

	const navigate = useNavigate();

	const { t } = useTranslation();

	useEffect(() => {
		initData();
	}, []);

	const becomeProRejected = () => {
		if (proStatus?.status === BecomeProStatuses.Rejected) {
			if (DateHelper.dateIsAfter(proStatus?.statusSetDate)) {
				return false;
			}
			return true;
		}
		return false;
	};

	const isDisableBecomeProBtn = () => {
		if (proStatus?.status === BecomeProStatuses.Requested) {
			return true;
		}

		return becomeProRejected();
	};

	const isShowBecomeProBtn = () => {
		if (
			proStatus?.status == null ||
			proStatus?.status === '' ||
			proStatus?.status === undefined
		) {
			return false;
		}

		return proStatus?.status !== BecomeProStatuses.Approved;
	};

	const initData = async () => {
		const [
			shortSummary,
			becomeProStatus,
			summaryData,
			activeAIId,
		] = await Promise.all([
			investorService.getInvestorSummaryShort(),
			becomeProService.getBecomeProStatus(),
			investorService.getInvestorsSummary(),
			investorService.getAutoInvest()
		]).catch((err) => {
			setLoading(false);
		});
		setSummary(summaryData?.data);
		setAvailableCash(shortSummary.data?.availableCash);
		setProStatus(becomeProStatus.data);
		setLoading(false);
		const selectedId = activeAIId.data?.type;
		setSelectedBucket(selectedId);
		if (activateInvest && !selectedId) {
			const url = new URL(window.location.href);
			url.searchParams.delete("activateInvest");
			window.history.replaceState(null, "", url.toString());
			setActivatedBucket(staticAI[0]);
			setTimeout(() => {
				onCloseBucketDialog(true, staticAI[0], shortSummary.data?.availableCash);
			}, 400);
		}
	};

	const activateBucket = (bucket = null, availCash = availableCash) => {
		let bucketId = bucket?.id || activatedBucket?.id;
		setSelectedBucket(bucketId);
		localStorage.setItem(
			`autoInvestClosingTime`,
			DateHelper.formatDate(new Date(), 'yyyy-MM-dd')
		);
		investorService
			.setInvestingMode(bucketId)
			.then((resp) => {
				setSelectedBucket(bucketId);
				if (availCash <= 0 && getUser()?.isApproved && bucketId) {
					confirm({
						description: t('youDontHaveEnoughMoney'),
						title: "",
						titleProps: { className: "!text-center !capitalize" },
						confirmationButtonProps: {
							className: '!primary-bg !text-white !capitalize !text-sm',
						},
						cancellationButtonProps: {
							style: { border: "1px solid #ccc" },
							className: '!bg-white !text-[#454545] !capitalize !text-sm',
						},
						dialogActionsProps: {
							className: "!justify-center !pb-4"
						},
						dialogProps: {
							style: { maxWidth: "500px", width: "100%" },
							className: "!mx-auto",
						},
						contentProps: { className: "!text-center !pb-1" },
						cancellationText: t('close'),
						confirmationText: t('deposit'),
					})
						.then(() => {
							setTimeout(() => {
								navigate({
									pathname: buildLocalizeRoute(
										`${AppRoutes.Investor}/${AppRoutes.ITransfer}/${AppRoutes.IDeposit}`
									)
								});
							}, 500);
						})
						.catch(() => { });
				}
			})
			.catch(() => { });
	};

	const onBucketSelect = (bucket) => {
		setActivatedBucket(bucket);
		setTimeout(() => {
			setIsOpenBucketDialog(true);
		});
	};

	const onCloseBucketDialog = (value, bucket = null, availCash = availableCash) => {
		setIsOpenBucketDialog(false);
		if (value) {
			if (systemSettingsService.systemSettings()?.enabledOtp) {
				setShowOTPDialog(true);
			} else {
				activateBucket(bucket, availCash);
			}
		}
	};

	const onOTPClose = (value) => {
		setShowOTPDialog(false);
		if (value) {
			activateBucket();
		}
	};

	const onBecomePro = () => {
		navigate(
			buildLocalizeRoute(
				`${AppRoutes.Investor}/${AppRoutes.Profile}/${AppRoutes.BecomeAPro}`
			)
		);
	};

	const isActive = (bucket) => bucket.id === selectedBucket;

	const boldPatterns = {
		autoInvestmentBalancedPortfolioText: /invest up to 10%|استثمر ما يصل إلى 10٪/,
		autoInvestmentAutomateInvestText: /achieve the optimal risk and return|تحقيق المفاضلة المثلى بين المخاطر والعائد/,
		autoInvestmentRiskIsMinimizedConservativeText: /boost your returns to 16%\.|تعزيز عوائدك بنسبة 16٪/,
		autoInvestmentConservativePortfolioText: /up to 5% of your total portfolio in one SME\.|ما يصل إلى 5٪ من إجمالي محفظتك في شركة واحدة/,
		autoInvestmentHigherProjectReturnsConservativeText: /prioritise capital preservation|الحفاظ على رأس المال/,
		autoInvestmentRiskIsMinimizedConservativeText1: /maximize your returns\.|تعظيم عوائدك/,
	};

	const renderBoldText = (key) => {
		const text = t(key);
		const pattern = boldPatterns[key];
		if (!pattern) return <span>{text}</span>;
		const html = text.replace(pattern, (match) => `<strong>${match}</strong>`);
		return <span dangerouslySetInnerHTML={{ __html: html }} />;
	};

	const renderBucketCard = (bucket) => {
		const active = isActive(bucket);
		const isBalanced = bucket.id === BucketTypes.Balanced;

		return (
			<div
				key={bucket.id}
				className="relative flex flex-col mt-[64px]"
			>
				{/* Activated badge — absolutely positioned above the card */}
				{active && (
					<div className="absolute -top-14 left-0 right-0 h-64 bg-investor-green rounded-3xl flex items-start gap-2 px-6 pt-4 z-0">
						<span className='flex items-center gap-1'>
							<CheckCircleOutlineIcon
								sx={{ fontSize: 20 }}
								className="text-investor-deep"
							/>
							<span className="text-lg font-bold tracking-wider uppercase text-investor-deep">
								{t('activated')}
							</span>
						</span>
					</div>
				)}

				{/* Card body */}
				<div
					className={`flex flex-col flex-1 relative z-10 rounded-3xl ${isBalanced ? 'bg-investor-card-active' : 'bg-investor-card-inactive'}`}
					style={{ padding: '37px 45px 63px 37px' }}
				>
					{/* Title */}
					<h2 className="text-[32px] font-bold text-investor-deep leading-tight">
						{bucket.title}
					</h2>

					{/* ROI */}
					<div className="border-t border-investor-deep mt-5 pt-4">
						<p className="text-sm text-investor-deep">
							{t('upToPercentage')}{' '}
							<span className="font-bold">
								{currencyFormatterHelper(bucket.roiPercent)}%
							</span>{' '}
							{t('projectedReturn').toLowerCase()}
						</p>
					</div>

					{/* Descriptions */}
					<div className="border-t border-investor-deep mt-4 pt-5 flex flex-col gap-5 flex-1">
						<p className="text-xs text-investor-deep leading-relaxed">
							{renderBoldText(
								isBalanced
									? 'autoInvestmentBalancedPortfolioText'
									: 'autoInvestmentConservativePortfolioText'
							)}
						</p>
						<p className="text-xs text-investor-deep leading-relaxed">
							{renderBoldText(
								isBalanced
									? 'autoInvestmentAutomateInvestText'
									: 'autoInvestmentHigherProjectReturnsConservativeText'
							)}
						</p>
						<p className="text-xs text-investor-deep leading-relaxed">
							{renderBoldText(
								isBalanced
									? 'autoInvestmentRiskIsMinimizedConservativeText'
									: 'autoInvestmentRiskIsMinimizedConservativeText1'
							)}
							{isBalanced && (
								<CustomTooltip
									tooltipClass="md:!max-w-[300px]"
									iconClassList="!m-0 !text-xs !relative !-top-0.5 !mx-0.5"
									id="autoInvestmentRiskIsMinimizedConservativeTextTooltipText"
									text={t('autoInvestmentRiskIsMinimizedConservativeTextTooltipText')}
								/>
							)}
						</p>
					</div>

					{/* Action button */}
					<div className="mt-auto pt-8 flex flex-col gap-4">
						{active ? (
							<button
								onClick={() => onBucketSelect(null)}
								className="w-full flex items-center gap-3 rounded-full bg-investor-deep text-white py-3.5 px-6 text-sm font-bold uppercase tracking-wider hover:opacity-90 transition-opacity"
							>
								<PauseCircleOutlineIcon sx={{ fontSize: 22 }} />
								{t('pauseAutoInvestment')}
							</button>
						) : (
							<button
								onClick={() => onBucketSelect(bucket)}
								className="w-full flex items-center gap-3 rounded-full bg-investor-deep text-white py-3.5 px-6 text-sm font-bold uppercase tracking-wider hover:opacity-90 transition-opacity"
							>
								<PlayCircleOutlineIcon sx={{ fontSize: 22 }} />
								{t('activate').toUpperCase()}
							</button>
						)}
						<p className="text-xs text-investor-deep leading-relaxed" style={{ visibility: active ? 'visible' : 'hidden' }}>
							{t('pauseInvestingText')}
						</p>
					</div>
				</div>
			</div>
		);
	};

	return (
		<Box>
			{!loading ? (
				<>
					{/* Hero section — 3-column layout */}
					<div className="grid grid-cols-1 lg:grid-cols-3 gap-6 items-stretch">
						{/* Left intro panel — offset down by banner height when a bucket is active */}
						<div className="bg-investor-bg rounded-2xl p-8 lg:p-10 flex flex-col justify-between mt-[64px]">
							<p
								className="text-investor-green text-3xl lg:text-4xl leading-snug"
								dangerouslySetInnerHTML={{
									__html: t('activateAutoInvestText')
										.replace(
											/(Auto Investing|الاستثمار الآلي)/,
											'<strong>$1</strong>'
										),
								}}
							/>
							<div className="mt-8 flex justify-end">
								<div className="w-32 h-32 rounded-full border-2 border-investor-green flex items-center justify-center">
									<ArrowForwardIcon
										sx={{ fontSize: 32 }}
										className={`text-investor-green ${languageService.isArabic() ? 'scale-x-[-1]' : ''}`}
									/>
								</div>
							</div>
						</div>

						{/* Bucket cards */}
						{buckets.map((bucket) => renderBucketCard(bucket))}
					</div>

					{/* Become Pro section */}
					{isShowBecomeProBtn() && (
						<Section
							classList="!mt-6 !p-0 !shadow-none"
							children={
								<Box className="flex flex-col md:flex-row md:items-center gap-4 py-5">
									<span className="flex-1 min-w-0">
										<TextWrapper
											type="span"
											classList="!font-bold"
											text={t('becomePro') + ' - '}
										/>
										<TextWrapper
											classList="currency-symbol"
											type="span"
											text={t('becomeProHintText', {
												depositRemained: currencyFormatterHelper(
													summary?.depositRemained
												),
												year: currentYear,
											})}
										/>
									</span>
									{!isDisableBecomeProBtn() ? (
										<ButtonWrapper
											onClick={() => onBecomePro()}
											label={t('upgrade')}
											classList="!w-full md:!w-auto !flex-shrink-0 !rounded-full !bg-investor-green !px-8 !font-bold !uppercase !tracking-wider !shadow-none"
										/>
									) : (
										<Box className="flex-shrink-0">
											<CustomTooltip
												id="pro"
												text={
													becomeProRejected()
														? t('becomeProRejectedText')
														: proStatus?.status === BecomeProStatuses.Requested
															? t('becomeProRequestCompleted')
															: ''
												}
												children={
													<ButtonWrapper
														disabled
														label={t('pending')}
														classList="!w-full md:!w-[120px] !rounded-full"
													/>
												}
											/>
										</Box>
									)}
								</Box>
							}
						/>
					)}

					{/* Footer disclaimer */}
					{!IS_SA && (
						<p className="text-xs text-gray-400 mt-6 leading-relaxed">
							{t('autoInvestmentFooterText')}
						</p>
					)}
				</>
			) : (
				<AutoInvestLoader />
			)}

			{isOpenBucketDialog && (
				<ConfirmAutoInvestDialog
					state={isOpenBucketDialog}
					bucket={activatedBucket}
					onClose={(e) => onCloseBucketDialog(e)}
				/>
			)}

			{showOTPDialog && (
				<OTPAuthenticationDialog
					type={OTPTypes.Other}
					state={showOTPDialog}
					onClose={(e) => onOTPClose(e)}
				/>
			)}
		</Box>
	);
};
